module.exports = __webpack_public_path__ + "media/images/cms/img_slide_08-3bcaef3e7b88c80aca7ae94ff0bff719.jpg";